import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMyProfiles } from '@/hooks/useProfile';
import { useAuthStore } from '@/stores/authStore';
import { Button } from '@/components/ui/Button';
import { useDaoConfig } from '@/hooks/useDaoConfig';
import ClientProfilePage from './ClientProfilePage';
import DeveloperProfilePage from './DeveloperProfilePage';

export default function ProfilePage() {
  const { workerRole, clientRole } = useDaoConfig();
  const query = useMyProfiles();
  const session = useAuthStore((state) => state.session);
  const role = useAuthStore((state) => state.user?.role);
  const location = useLocation();
  const fallbackRole = query.data?.client ? 'client' : 'developer';
  useEffect(() => {
    const current = useAuthStore.getState();
    if (
      query.data &&
      current.session &&
      !current.user?.role &&
      current.session.principalId === query.data.principalId
    )
      current.setSession(current.session, fallbackRole);
  }, [query.data, fallbackRole]);
  if (query.isPending)
    return (
      <p role="status" className="pageContent">
        Loading profile…
      </p>
    );
  if (query.isError)
    return (
      <div className="pageContent">
        <p role="alert">{query.error.message}</p>
        <Button onClick={() => void query.refetch()}>Retry profile</Button>
      </div>
    );
  if (!session || !query.data) return null;
  const selected = role ?? (query.data.client ? 'client' : 'developer');
  const selectedLabel = selected === 'client' ? clientRole : workerRole;
  const profile = selected === 'client' ? query.data.client : query.data.worker;
  return (
    <div className="w-full">
      {!profile ? (
        <div className="pageContent">
          <h1>No {selectedLabel} profile yet</h1>
          <p>Your account is already created.</p>
          <Link to={'/register/' + selected}>Complete {selectedLabel.toLowerCase()} profile</Link>
        </div>
      ) : selected === 'client' && query.data.client ? (
        <ClientProfilePage
          key={session.principalId + selected}
          profile={query.data.client}
          principalId={session.principalId}
          startInEditMode={location.pathname === '/profile/edit'}
        />
      ) : (
        query.data.worker && (
          <DeveloperProfilePage
            key={session.principalId + selected}
            profile={query.data.worker}
            principalId={session.principalId}
            startInEditMode={location.pathname === '/profile/edit'}
          />
        )
      )}
    </div>
  );
}
